import { CustomCellRendererProps } from "@ag-grid-community/react";
import {Chip} from "@mui/material";


const QuantityRenderer = ({value}: CustomCellRendererProps) => (
  <Chip label={value} variant='secondaryBadge' />)

export default QuantityRenderer;